import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { isMobileDevice } from '@/lib/mobile';

/**
 * Component that redirects mobile users from desktop routes to mobile routes
 * Should be placed at the root level to catch all desktop routes
 */
export default function MobileRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const isMobile = isMobileDevice();
    const isMobileRoute = location.pathname.startsWith('/m/');
    
    // Exclude public landing pages from mobile redirect
    const publicRoutes = ['/testlanding', '/'];
    const publicRoutePrefixes = ['/book', '/testimonials'];
    
    // Check if current path is a public route
    if (publicRoutes.includes(location.pathname)) {
      return; // Don't redirect public landing pages
    }
    
    // Check if current path starts with a public route prefix (e.g., /book/org-5)
    if (publicRoutePrefixes.some(prefix => location.pathname.startsWith(prefix))) {
      return; // Don't redirect public pages
    }
    
    // Only redirect if:
    // 1. User is on mobile device
    // 2. Current path is NOT already a mobile path
    if (isMobile && !isMobileRoute) {
      // Map desktop routes to mobile routes
      let mobilePath = '/m/contracts'; // default
      
      if (location.pathname === '/scooters') mobilePath = '/m/scooters';
      else if (location.pathname === '/clients') mobilePath = '/m/clients';
      else if (location.pathname === '/contracts') mobilePath = '/m/contracts';
      else if (location.pathname === '/finance') mobilePath = '/m/maintenance';
      else if (location.pathname === '/login') mobilePath = '/m/login';
      else if (location.pathname === '/dashboard') mobilePath = '/m/contracts';
      
      navigate(mobilePath, { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
}

